import styles from "../Daetong.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import HeaderMain from "../component/HeaderMain";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UnseContext } from "../context/UnseContext";

function FortuneInfo({ setFortuneList, menuList, Loading, Constellation, cards }) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    let memberId = localStorage.getItem("daetong_memberId");
    const [data, setData] = useState({});
    const [myNameCheck, setMyNameCheck] = useState(true);
    const [partnerNameCheck, setPartnerNameCheck] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const isValidMember = memberId && memberId !== "null";
    const inputRef = useRef({});
    const { orderId } = useParams();
    const { setUnseData } = useContext(UnseContext);
    const navigate = useNavigate();
    const orderIdNum = Number(orderId);
    const item = cards.find(card => Number(card.ORDER_ID) === orderIdNum);
    const siteCode = process.env.REACT_APP_SITE_CODE_DAETONG;
    const [isLocked, setIsLocked] = useState(false);


    const [AGREE_PRIVACY, setAgreePrivacy] = useState(() => {
        try {
            const parsed = memberId ? JSON.parse(memberId) : null;
            return parsed != null; 
        } catch (e) {
            return false;
        }
    });



    // ★ 운세 결과값 가져오기(gpt) - Promise 반환 / 로딩·페이지이동 없음
    function getUnse(unseId, memberId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${API_BASE_URL}/getUnse`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify({ "unse_id": unseId, "member_id": memberId, "site_code": siteCode }),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    if (res.code != "0") {
                        alert(res.msg);
                        return reject(new Error(res.msg || "운세 조회 실패"));
                    }
                    // console.log("운세 응답:", res);
                    resolve(res); // 여기서 데이터만 넘김
                },
                error: function (xhr, status, err) {
                    console.error("운세 에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                    reject(err);
                },
            });
        });
    }

    // ★ 회원 정보 저장(procMember)도 Promise로 래핑
    function procMember(form) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${API_BASE_URL}/procMember`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(form),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    if (res.code != "0") {
                        alert(res.msg);
                        return reject(new Error(res.msg || "회원정보 저장 실패"));
                    }
                    // console.log("회원 저장 응답:", res);
                    localStorage.setItem("daetong_memberId", res.member_id);
                    resolve(res.member_id); // 새 member_id 반환
                },
                error: function (xhr, status, err) {
                    console.error("회원 저장 에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                    reject(err);
                },
            });
        });
    }

    // 첫 마운트 유저 정보 가져오기
    useEffect(() => {
        $.ajax({
            url: `${API_BASE_URL}/postMember`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                "member_id": memberId, "site_code": siteCode
            }),
            cache: false,
            headers: {
                APIKEY: APIKEY,
            },
            success: function (res) {
                if (res.code != "0") {
                    alert(res.msg); return false;
                }
                setData(res.memberRow);
                // console.log("postMember 응답:", res);
            },
            error: function (xhr, status, err) {
                console.error("postMember 에러:", err);
                // console.log("상태:", xhr.status, "응답:", xhr.responseText);
            },
        });
        localStorage.setItem("daetong_memberId", memberId);

    }, []);

    const [form, setForm] = useState({
        //내정보
        NAME: '',
        SEX: '남자',
        BIRTHDAY: '',
        BIRTHDATE: '',
        CALENDAR_TYPE: '양력',
        member_id: '',
        site_code: siteCode
    });

    //첫 통신에 데이터가 없는경우 데이터 저장
    useEffect(() => {
        setForm(prev => ({
            ...prev,
            //내정보
            NAME: data.NAME ?? '',
            SEX: data.SEX ?? '남자',
            BIRTHDAY: data.BIRTHDAY ?? '',
            BIRTHDATE: data.BIRTHDATE ?? '',
            CALENDAR_TYPE: data.CALENDAR_TYPE ?? '양력',
            member_id: memberId ?? '',
            site_code: siteCode
        }));
    }, [data, memberId]);

    //input 정규식
    const handleChange = (e) => {
        const { id, value } = e.target;

        if (id === "NAME" || id === "PARTNER_NAME") {
            let newValue = value;
            newValue = newValue.replace(/[A-Za-z0-9]/g, "");

            if (newValue.length > 6) {
                newValue = newValue.slice(0, 6);
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));

            const hasChoseong = /[ㄱ-ㅎ]/.test(newValue);
            const isValid = !!newValue && !hasChoseong;

            if (id === "NAME") {
                setMyNameCheck(isValid);
            } else if (id === "PARTNER_NAME") {
                setPartnerNameCheck(isValid);
            }
            return;
        }

        if (id === "BIRTHDAY" || id === "PARTNER_BIRTHDAY") {
            let digits = value.replace(/[^0-9]/g, "");
            digits = digits.slice(0, 8);

            let newValue = "";
            if (digits.length <= 4) {
                newValue = digits;
            } else if (digits.length <= 6) {
                newValue = `${digits.slice(0, 4)}.${digits.slice(4)}`;
            } else {
                newValue = `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));
            return;
        }

        if (id === "BIRTHDATE" || id === "PARTNER_BIRTHDATE") {
            let digits = value.replace(/[^0-9]/g, "");
            digits = digits.slice(0, 4);

            let newValue = "";
            if (digits.length <= 2) {
                newValue = digits;
            } else {
                newValue = `${digits.slice(0, 2)}:${digits.slice(2)}`;
            }

            setForm((prev) => ({
                ...prev,
                [id]: newValue,
            }));
            return;
        }

        setForm((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleClear = (id) => {
        setForm((prev) => ({
            ...prev,
            [id]: "",
        }));
    };

    const handleRadio = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleUnknownBirth = (e) => {
        const checked = e.target.checked;
        setForm(prev => ({
            ...prev,
            BIRTHDATE: checked ? '시간 모름' : '',
        }));
    };

    const setInputRef = (name) => (el) => {
        inputRef.current[name] = el;
    };

    // ★ 사용자 정보 보내기 + 운세 + 광고까지 한 번에 처리
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.NAME == "" || myNameCheck == false) {
            alert('이름을 확인해주세요.');
            inputRef.current['NAME']?.focus();
            return;
        }
        if (form.SEX == "") {
            alert('성별을 체크해주세요.');
            inputRef.current['SEX']?.focus();
            return;
        }
        if (form.BIRTHDAY == "" || form.BIRTHDAY.length < 10) {
            alert('생년월일을 확인해주세요.');
            inputRef.current['BIRTHDAY']?.focus();
            return;
        }
        if (form.CALENDAR_TYPE == "") {
            alert('양력/음력을 선택해주세요.');
            inputRef.current['CALENDAR_TYPE']?.focus();
            return;
        }
        if (form.BIRTHDATE == "" || form.BIRTHDATE.length < 5) {
            alert('태어난 시간을 확인해주세요.');
            inputRef.current['BIRTHDATE']?.focus();
            return;
        }
        if (!AGREE_PRIVACY) {
            alert('개인정보 수집 / 이용 동의에 동의해주세요');
            return;
        }


        try {
            // 1) 회원 정보 저장
            const newMemberId = await procMember(form);
            memberId = newMemberId; // 로컬 변수 업데이트

            // 운세 카드 없이 단순 정보 저장만 한 경우
            if (orderId === undefined) {
                alert('회원정보가 저장되었습니다.');
                window.location.href = "/daetong";
                return;
            }

        if (isLocked) return;

            setIsLocked(true);

            // 2) 운세 요청을 백그라운드에서 먼저 시작
            const unsePromise = getUnse(orderId, newMemberId);

            // 3) 그 사이에 Flutter 리워드 광고 표시
            let adResult = { success: true }; // 브라우저 테스트용 기본값

            try {
                if (
                    window.flutter_inappwebview &&
                    typeof window.flutter_inappwebview.callHandler === "function"
                ) {
                    // Flutter 쪽에서 { success: true/false } 형태로 내려준다고 가정
                    adResult = await window.flutter_inappwebview.callHandler("showRewardAd");
                } else {
                    console.log("flutter_inappwebview 없음 - 브라우저에서 광고 없이 진행");
                }
            } catch (adErr) {
                console.error("광고 호출 중 에러:", adErr);
                // 여기서 실패를 광고 미시청으로 처리할지, 그냥 통과시킬지는 정책에 따라
                // 일단은 실패 = 광고 미시청으로 보려면 success=false로 두면 됨
                adResult = { success: false };
            }

            // 3-1) 광고를 끝까지 안 본 경우 → 운세 보여주지 않고 메인으로
            if (!adResult || adResult.success !== true) {
                alert('광고 시청을 끝까지 해주세요.');
                // 백그라운드로 돌고 있던 운세 Promise는 결과를 버리기만 하면 됨
                unsePromise
                    .then(() => { })
                    .catch(() => { });
                // 메인으로 이동
                window.location.href = "/daetong";
                return;
            }

            // 4) 광고가 끝난 시점부터 로딩 화면 ON
            setIsLoading(true);

            // 5) 운세 API 결과 대기 (이미 끝났으면 바로 통과)
            const res = await unsePromise;

            // 6) 운세 데이터 세팅 + 이동
            localStorage.setItem("daetong_unseLogId", res.unse_log_id);
            setUnseData(res);

            // 필요하다면 리스트 닫기
            if (setFortuneList) {
                setFortuneList(false);
            }

            navigate("/daetong/UnseResult");
        } catch (err) {
            console.error("전체 처리 중 에러:", err);
            alert("처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <Loading Constellation={Constellation} />;
    }


    return (
        <div className="FortuneInfoPage_inner">
            <div className={`FortuneInfoContent ${styles.FortuneInfoContent_daetong}`}>
                <div className="infoTItleBox">
                    <h2 className="title">운세 정보 입력</h2>
                    {
                        item == undefined ? null : <span>{`(${item?.TITLE})`}</span>
                    }
                </div>
                <p className="subTitle">
                    당신만의 운세를 정확히 보기 위해 운세 정보를 입력해주세요.<br />
                    (한 번만 입력하시면 이 후 자동으로 적용됩니다.)
                </p>

                <form onSubmit={handleSubmit}>
                    {/* 내 정보 */}
                    <section>
                        {/* 이름 */}
                        <div id="NAME" className="nameBox">
                            <label htmlFor="NAME" className="infoTitle">나의 이름</label>
                            <div className="nameInput">
                                <input
                                    id="NAME"
                                    type="text"
                                    value={form.NAME}
                                    onChange={handleChange}
                                    placeholder="이름을 입력해주세요."
                                    disabled={isLocked}
                                    ref={setInputRef('NAME')}
                                />
                                {
                                    form.NAME && (
                                        <button className="cleanBtn" onClick={() => handleClear("NAME")}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                            {
                                myNameCheck
                                    ? <span className="notice">한글 최대 6자</span>
                                    : <span className="nameCheck">정확한 이름을 입력해주세요.</span>
                            }
                        </div>

                        {/* 성별 */}
                        <div>
                            <span className="infoTitle">나의 성별</span>
                            <div className="sexBox">
                                <label htmlFor="M">
                                    <input
                                        id="M"
                                        name="SEX"
                                        type="radio"
                                        value="남자"
                                        disabled={isLocked}
                                        checked={form.SEX === "남자"}
                                        onChange={handleRadio}
                                    />
                                    <span>남자</span>
                                </label>
                                <label htmlFor="F">
                                    <input
                                        id="F"
                                        name="SEX"
                                        type="radio"
                                        value="여자"
                                        disabled={isLocked}
                                        checked={form.SEX === "여자"}
                                        onChange={handleRadio}
                                    />
                                    <span>여자</span>
                                </label>
                            </div>
                        </div>

                        {/* 생년월일 */}
                        <div>
                            <label htmlFor="BIRTHDAY" className="infoTitle">나의 생년월일</label>
                            <div className="absoluteBox">
                                <input id="BIRTHDAY" type="text" maxLength={10} value={form.BIRTHDAY} onChange={handleChange} disabled={isLocked} placeholder="1900.01.01" />
                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="radio"
                                            name="CALENDAR_TYPE"
                                            value="양력"
                                            checked={form.CALENDAR_TYPE === "양력"}
                                            disabled={isLocked}
                                            onChange={handleRadio}
                                        />
                                        <span>양력</span>
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="CALENDAR_TYPE"
                                            value="음력"
                                            checked={form.CALENDAR_TYPE === "음력"}
                                            disabled={isLocked}
                                            onChange={handleRadio}
                                        />
                                        <span>음력</span>
                                    </label>
                                </div>
                                {
                                    form.BIRTHDAY && (
                                        <button className="cleanBtn" onClick={(() => { handleClear("BIRTHDAY") })}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                        </div>

                        {/* 태어난 시간 */}
                        <div>
                            <label htmlFor="BIRTHDATE" className="infoTitle">태어난 시간</label>
                            <div className="absoluteBox">
                                <input
                                    id="BIRTHDATE"
                                    name="BIRTHDATE"
                                    type="text"
                                    maxLength={5}
                                    // "시간 모름"일 때는 input에는 안 보이게
                                    value={form.BIRTHDATE === '시간 모름' ? '시간 모름' : (form.BIRTHDATE || '')}
                                    onChange={handleChange}
                                    placeholder="12:00"
                                    disabled={isLocked || form.BIRTHDATE === '시간 모름'}
                                />

                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="checkbox"
                                            // 체크 여부도 값으로 판단
                                            checked={form.BIRTHDATE === '시간 모름'}
                                            onChange={handleUnknownBirth}
                                            disabled={isLocked}
                                        />
                                        <span>시간 모름</span>
                                    </label>
                                </div>

                                {/* 값이 있고, 그 값이 "시간 모름"이 아닐 때만 클리어 버튼 노출 */}
                                {form.BIRTHDATE && form.BIRTHDATE !== '시간 모름' && (
                                    <button
                                        type="button"
                                        className="cleanBtn timeBtn"
                                        onClick={() => handleClear('BIRTHDATE')}
                                    >
                                        <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </section>

                    {/* <section>
                        <h4 className="partnerTitle">상대 정보 입력</h4>

                        <div className="nameBox">
                            <label htmlFor="PARTNER_NAME" className="infoTitle">상대방의 이름</label>
                            <div className="nameInput">
                                <input
                                    id="PARTNER_NAME"
                                    type="text"
                                    value={form.PARTNER_NAME}
                                    onChange={handleChange}
                                    placeholder="이름을 입력해주세요."
                                />
                                {
                                    form.PARTNER_NAME && (
                                        <button className="cleanBtn" onClick={(() => { handleClear("PARTNER_NAME") })}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                            {
                                partnerNameCheck
                                    ? <span className="notice">한글 최대 6자</span>
                                    : <span className="nameCheck">정확한 이름을 입력해주세요.</span>
                            }
                        </div>

                        <div>
                            <span className="infoTitle">상대 성별</span>
                            <div className="sexBox">
                                <label htmlFor="PARTNER_M">
                                    <input
                                        id="PARTNER_M"
                                        name="PARTNER_SEX"
                                        type="radio"
                                        value="남자"
                                        checked={form.PARTNER_SEX === "남자"}
                                        onChange={handleRadio}
                                    />
                                    <span>남자</span>
                                </label>
                                <label htmlFor="PARTNER_F">
                                    <input
                                        id="PARTNER_F"
                                        name="PARTNER_SEX"
                                        type="radio"
                                        value="여자"
                                        checked={form.PARTNER_SEX === "여자"}
                                        onChange={handleRadio}
                                    />
                                    <span>여자</span>
                                </label>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="PARTNER_BIRTHDAY" className="infoTitle">상대방의 생년월일</label>
                            <div className="absoluteBox">
                                <input id="PARTNER_BIRTHDAY" type="text" maxLength={10} value={form.PARTNER_BIRTHDAY} onChange={handleChange} placeholder="1900.01.01" />
                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="radio"
                                            name="PARTNER_CALENDAR_TYPE"
                                            value="양력"
                                            checked={form.PARTNER_CALENDAR_TYPE === "양력"}
                                            onChange={handleRadio}
                                        />
                                        <span>양력</span>
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="PARTNER_CALENDAR_TYPE"
                                            value="음력"
                                            checked={form.PARTNER_CALENDAR_TYPE === "음력"}
                                            onChange={handleRadio}
                                        />
                                        <span>음력</span>
                                    </label>
                                </div>
                                {
                                    form.PARTNER_BIRTHDAY && (
                                        <button className="cleanBtn" onClick={(() => { handleClear("PARTNER_BIRTHDAY") })}>
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )
                                }
                            </div>
                        </div>

                        <div>
                            <label htmlFor="PARTNER_BIRTHDATE" className="infoTitle">상대방 태어난 시간</label>
                            <div className="absoluteBox">
                                <input
                                    id="PARTNER_BIRTHDATE"
                                    name="PARTNER_BIRTHDATE"
                                    type="text"
                                    maxLength={5}
                                    value={form.PARTNER_BIRTHDATE === '시간 모름' ? '' : (form.PARTNER_BIRTHDATE || '')}
                                    onChange={handleChange}
                                    placeholder="12:00"
                                    disabled={form.PARTNER_BIRTHDATE === '시간 모름'}
                                />

                                <div className="absoluteContent">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={form.PARTNER_BIRTHDATE === '시간 모름'}
                                            onChange={handlePartnerUnknownBirth}
                                        />
                                        <span>시간 모름</span>
                                    </label>
                                </div>

                                {form.PARTNER_BIRTHDATE &&
                                    form.PARTNER_BIRTHDATE !== '시간 모름' && (
                                        <button
                                            type="button"
                                            className="cleanBtn"
                                            onClick={() => handleClear('PARTNER_BIRTHDATE')}
                                        >
                                            <img src={process.env.PUBLIC_URL + "/image/clean_text.png"} />
                                        </button>
                                    )}
                            </div>
                        </div>

                    </section> */}

                    <div className="personalInfoCollection">
                        <label htmlFor="agreePrivacy">
                            <input
                                id="agreePrivacy"
                                type="checkbox"
                                name="agreePrivacy"
                                disabled={isLocked}
                                checked={AGREE_PRIVACY}
                                onChange={(e) => setAgreePrivacy(e.target.checked)}
                            />
                            <span>개인정보 수집 / 이용 동의</span>
                        </label>
                        {/* <button type="button" className="viewBtn" onClick={(() => {
                                setAgreePrivacyTab(true);
                                if (agreePrivacyTab) {
                                    document.documentElement.classList.add("scrollNone");
                                } else {
                                    document.documentElement.classList.remove("scrollNone");
                                }
                            })}>약관보기</button> */}
                        <Link to="/daetong/AgreePrivacy" className="viewBtn">약관보기</Link>
                    </div>
                    {
                        orderId !== undefined && isValidMember
                            ? <button type="submit" className="submitBtn" disabled={isLocked}>결과보기</button>
                            : <button type="submit" className="submitBtn" disabled={isLocked}>저장하기</button>
                    }

                    {/* <div className={agreePrivacyTab ? "agreePrivacyPage active" : "agreePrivacyPage"}>
                            <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} agreePrivacyTab={agreePrivacyTab}/>
                            <AgreePrivacy></AgreePrivacy>
                        </div> */}
                </form>
            </div>
        </div>
    )
}
export default FortuneInfo;





